import { IEmployee } from '../../services/employees.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { EmployeesService, DeclarationService } from "../../services/index";
import { IGetShiftListParams, IShift, ShiftService } from '../../services/shifts.service';
import * as angular from 'angular';

class ScheduleListController implements ng.IComponentController {
    availibility: any;
    private isMessageOpen: boolean;
    private currentShift: any;
    private groupedShifts: any;
    private shiftsGrouping: any;
    private shifts: IShift[];
    private filter: any;

    private sortType: any;
    private moment: any;
    private employee: IEmployee;
    private months: Array<String>;
    private startDate: any;
    private endDate: any;

    constructor(
        private EmployeesService: EmployeesService,
        private DeclarationService: DeclarationService,
        private ShiftService: ShiftService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private $timeout: ng.ITimeoutService,
        private $filter: any,
        private screenSize: any
    ) {
        'ngInject';

        this.months = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
    }

    public $onInit = () => {

        this.shiftsGrouping = 'date';

        this.filter = {
            status: null
        }

        this.moment = require('moment');
        if (this.$stateParams["start"]) {
            this.startDate = this.moment.utc(this.$stateParams["start"]).startOf('isoweek').format();
            this.endDate = this.moment.utc(this.$stateParams["start"]).endOf('isoweek').format();
        } else {
            this.startDate = this.moment().startOf('isoweek').format();
            this.endDate = this.moment().endOf('isoweek').format();
        }

        this.isMessageOpen = false;
        this.getShifts();
        
        //this.getAvailibility();

        // this.getShiftsByDate();

        // this.DeclarationService.subscribe('ScheduleListController', (type) => {
        //     var currentShift: IShift;
        //     switch (type) {
        //         case 'post': {
        //             currentShift = this.employee.shifts.find(s => s.id == this.DeclarationService.item.shiftId);
        //             // console.log(this.currentEmployee)
        //             // console.log(this.DeclarationService.item)
        //             // console.log(currentShift)
        //             currentShift.declarations.push(this.DeclarationService.item);
        //             this.updateShiftDeclarationsSummary(currentShift);
        //             break;
        //         }
        //         case 'put': {
        //             currentShift = this.employee.shifts.find(s => s.id == this.DeclarationService.item.shiftId);
        //             currentShift.declarations = currentShift.declarations.filter(s => s.id !== this.DeclarationService.item.id);
        //             currentShift.declarations.push(this.DeclarationService.item);
        //             this.updateShiftDeclarationsSummary(currentShift);
        //             break;
        //         }
        //         case 'delete': {            
        //             currentShift = this.employee.shifts.find(s => s.id == this.DeclarationService.item.shiftId);
        //             // console.log(this.currentEmployee)
        //             // console.log(this.DeclarationService.item)
        //             // console.log(currentShift)
        //             this.updateShiftDeclarationsSummary(currentShift);
        //             break;
        //         }
        //     }
        // });
    }

    public $onDestroy = () => {
        //this.DeclarationService.unsubscribe('ScheduleListController');
    }

    // updateShiftDeclarationsSummary(currentShift) {
    //     console.log('updateShiftDeclarationsSummary')
    //     this.ShiftService.customGet(this.DeclarationService.item.shiftId + '/shiftDeclarations').then((result) => {
    //         currentShift.plannedHours = result.plannedHours;
    //         currentShift.declaredHours = result.declaredHours;
    //         currentShift.hoursDifference = result.hoursDifference;

    //         // this.EmployeesService.customGet(this.DeclarationService.item.employeeId + '/employeeSummary', {from: this.startDate, till: this.endDate}).then((result) => {
    //         //     this.employee.shiftHours = result.shiftHours;
    //         //     this.employee.shiftDeclarationHours = result.shiftDeclarationHours;
    //         // });
    //     });
    // }

    public getShifts = (scrollTo = true) => {
        this.ShiftService.getByCurrentEmployee(this.startDate, this.endDate).then((result) => {
            this.shifts = result;
            this.filterShifts(scrollTo);
        });
    }

    public getAvailibility = (scrollTo = true) => {

        this.EmployeesService.getAvailabilityByRange(this.startDate, this.endDate).then((result) => {
            this.availibility = result;
            this.availibility.forEach(item => {
                var dates = this.getDateBetween(item.start, item.end);
                dates.forEach(date => {
                    //console.log(moment(date).format("YYYY-MM-DD"));
                    var n = angular.copy(item);
                    n.start = moment(date).format("YYYY-MM-DD");
                    n.end = moment(date).format("YYYY-MM-DD");
                    this.shifts.push(n);
                    //console.log(this.availibility);

                });
                if (dates.length > 0) {
                    item.end = moment(item.start).format("YYYY-MM-DD");
                    this.shifts.push(item);
                } else {
                    this.shifts.push(item);
                }

            });

            //this.shifts = //_.merge(this.shifts, this.availibility);

            this.filterShifts(scrollTo);
        });
    }

    private getDateBetween = (start, end) => {
        var dates = [];
        var startdate = moment(start).startOf('day');
        var lastDate = moment(end).startOf('day');

        while (startdate.add(1, 'days').diff(lastDate) < 0) {
            //console.log(startdate.toDate());
            dates.push(startdate.clone().toDate());
        }
        return (dates);
    }

    public filterShifts = (scrollTo = true) => {

        if (this.shiftsGrouping && this.shiftsGrouping == 'date') {
            this.groupedShifts = _.groupBy(this.shifts, (item) => {
                return moment(item.start).format('dd DD-MM-YYYY');
            });
        }
    }

    public handleChildChange = (type, data) => {
        // console.log(type);
        switch (type) {
            case 'init':
                this.isMessageOpen = true;
                break;
            default:
                break;
        }
    }

    prevWeek() {
        this.startDate = this.moment.utc(this.startDate).add(-7, 'day').format();
        this.endDate = this.moment.utc(this.endDate).add(-7, 'day').format();
        this.getShifts();
    }

    nextWeek() {
        this.startDate = this.moment.utc(this.startDate).add(7, 'day').format();
        this.endDate = this.moment.utc(this.endDate).add(7, 'day').format();
        this.getShifts();
    }

    // getShiftsByDate() {
    //     this.EmployeesService.customAll('employeeSummary', { from: this.startDate, till: this.endDate }).then((result: any) => {
    //         this.employee = result[0];
    //     });
    // }

    startDateBeforeRender($dates) {
    }

    endDateBeforeRender($view, $dates) {
        if (this.startDate) {
            var activeDate = moment(this.startDate).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }
}

export const scheduleListComponent: ng.IComponentOptions = {
    bindings: {
    },
    controller: ScheduleListController,
    template: <string>require('./schedule.list.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/schedule/schedule.list.component.ts